var _style, _path, _path2, _defs, _use, _clipPath, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".email-white_svg__st8{fill:#fff}.email-white_svg__st9{clip-path:url(#email-white_svg__SVGID_2_)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M675.6 209.3c0 18.1 14.7 32.7 32.7 32.7s32.7-14.7 32.7-32.7c0-18.1-14.7-32.7-32.7-32.7s-32.7 14.6-32.7 32.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M923.2 176.5H803.7c-18.1 0-32.7 14.7-32.7 32.7 0 18.1 14.7 32.7 32.7 32.7h98.9L513.8 630.8 121.7 242h491c18.1 0 32.7-14.7 32.7-32.7 0-18.1-14.7-32.7-32.7-32.7H100.8c-50.3 0-91.2 40.9-91.2 91.2v584.6c0 50.3 40.9 91.2 91.2 91.2h822.3c50.3 0 91.2-40.9 91.2-91.2V267.7c.1-50.3-40.8-91.2-91.1-91.2zM75.1 831.8V287.9l273.1 270.7L75.1 831.8zm873.8 0L677.2 560l271.7-271.7v543.5zm-827.5 46.3l273.3-273.3 93 92.2s9.4 12.6 25.2 12.6c6.9 0 15.1-2.4 24.3-9.5l93.8-93.8L902.7 878H121.4v.1z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "email-white_svg__SVGID_5_",
    d: "M923.2 176.5H803.7c-18.1 0-32.7 14.7-32.7 32.7 0 18.1 14.7 32.7 32.7 32.7h98.9L513.8 630.8 121.7 242h491c18.1 0 32.7-14.7 32.7-32.7 0-18.1-14.7-32.7-32.7-32.7H100.8c-50.3 0-91.2 40.9-91.2 91.2v584.6c0 50.3 40.9 91.2 91.2 91.2h822.3c50.3 0 91.2-40.9 91.2-91.2V267.7c.1-50.3-40.8-91.2-91.1-91.2zM75.1 831.8V287.9l273.1 270.7L75.1 831.8zm46.3 46.3l273.3-273.3 93 92.2s19.5 26.2 49.4 3.1l93.8-93.8L902.6 878H121.4zm827.5-46.3L677.2 560l271.7-271.7v543.5z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    xlinkHref: "#email-white_svg__SVGID_5_"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "email-white_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#email-white_svg__SVGID_5_"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M612.8 242H121.7l392.1 388.8L902.6 242H708.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.4 315.1L17.3 231v-63.5l982.2-2.5 10.6 75-63.4 50.4-382.1 382.2L525 775l-72.8-113.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default ForwardRef;